/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <k.pawlak@gmail.com>, March 2026
 */

/* eslint-disable max-len */
/* flow-disable */

import React from 'react';

import { isMobileView } from '../../../components/utils/utils'
import PowrotDoListyEuslug from '../../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../../components/EmptyFileDownloader';
import ServiceCardDownloader from '../../../components/ServiceCardDownloader/ServiceCardDownloader';
import { renderSaveDraftButton } from '../../../components/DraftManagement/draftManager';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
};


class ButtonsPanel extends React.Component {

  renderEmptyFileDownloader = (isMobile = false) => {
    const { prefix, shortName, serviceTitle, servicesWithoutTemplates } = this.props;

    if (servicesWithoutTemplates && servicesWithoutTemplates.includes(shortName)) {
      return null;
    }

    return (
      <EmptyFileDownloader
        prefix={prefix}
        serviceType={shortName}
        title={serviceTitle}
        className={isMobile && "mobile-button"}
      />
    );
  };

  renderServiceCardDownloader = (isMobile = false) => {
    const { prefix, shortName } = this.props;

    return (
      <ServiceCardDownloader
        prefix={prefix}
        serviceType={shortName}
        className={isMobile && "mobile-button"}
        style={{ marginLeft: 10 }}
      />
    );
  };

  renderCancelButton = () => {
    const { onCancel } = this.props;

    return (
      <button
        type="button"
        className="btn btn-default"
        style={btnStyle}
        onClick={onCancel}
      >
        Anuluj
      </button>
    );
  };

  renderRunButton = () => {
    const { onSave } = this.props;

    return (
      <button
        type="button"
        className="btn btn-primary"
        style={btnStyle}
        onClick={onSave}
      >
        Uruchom
      </button>
    );
  };

  render() {
    const { prefix, showDrafts, onDraftSave } = this.props;

    const isMobile = isMobileView(window);

    let showServiceCardDownloader = false;

    // gmina_olesno_powiat_oleski - special case for showing ServiceCardDownloader
    // in other districts - do not show
    if (['gmina_olesno_powiat_oleski'].includes(prefix)) {
      if (parentComponent === 'EServices') {
        showServiceCardDownloader = shortName === 'WypisIWyrysZMpzp';
      } else {
        showServiceCardDownloader = true;
      }
    }

    return (
      <div className="row mobile-row">
        {isMobile ? 
          <div>
            <div className="col-sm-12">
              <PowrotDoListyEuslug prefix={prefix} className="mobile-button"/>
              {this.renderEmptyFileDownloader(true)}
              {showServiceCardDownloader && this.renderServiceCardDownloader(true)}
              {showDrafts && renderSaveDraftButton(onDraftSave, true)}
            </div>
            <div className="col-sm-12 mobile-div">
              {this.renderCancelButton()}
              {this.renderRunButton()}
            </div>
          </div>
          :
          <div>
            <div className="col-sm-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              {/* lewa strona */}
              <div style={{ display: 'flex' }}>
                <PowrotDoListyEuslug prefix={prefix}/>
                {this.renderEmptyFileDownloader()}
              </div>

              {/* prawa strona */}
              <div style={{ display: 'flex', gap: '20px', marginRight: '15px' }}>
                {this.renderCancelButton()}
                {showDrafts && renderSaveDraftButton(onDraftSave)}
                {this.renderRunButton()}
              </div>

            </div>
            <div className="col-sm-12">
              {showServiceCardDownloader && this.renderServiceCardDownloader()}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ButtonsPanel;


// WEBPACK FOOTER //
// src/routes/eservices/utils/ButtonsPanel.js